import React, { useState, useEffect } from "react";
import { List, Button, Modal, Spin } from "antd";
import http from "../../helpers/http";
import config from "../../config/config";
import PaymentHistory from "./PaymentHistory";
import helper from "../../helpers/helper";

const SubscriptionLogs = ({ userId }) => {
  const [subscriptions, setSubscriptions] = useState([]);
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [paymentModalVisible, setPaymentModalVisible] = useState(false);
  const [selectedSubscription, setSelectedSubscription] = useState(null);

  const subscriptionStates = {
    pending: "Pending",
    active: "Active",
    payment_pending: "Payment Pending",
    suspended: "Suspended",
    expired: "Expired",
    cancelled: "Cancelled",
  };

  const fetchSubscriptions = async () => {
    setLoading(true);

    const data = await http.get(
      `${config.api_url}admin/business-users/subscriptions/${userId}`
    );

    if (data?.data) {
      setSubscriptions(data?.data);
    }

    setLoading(false);
  };
  const fetchPayments = async (subscriptionId) => {
    setLoading(true);

    const data = await http.get(
      `${config.api_url}admin/business-users/payments/${subscriptionId}`
    );

    if (data?.data) {
      setPayments(data?.data);
    }

    setLoading(false);
  };

  useEffect(() => {
    if (userId) {
      fetchSubscriptions();
    }
  }, [userId]);

  const handleViewPaymentHistory = (subscriptionId) => {
    fetchPayments(subscriptionId);
    setPaymentModalVisible(true);
  };

  const handleClosePaymentModal = () => {
    setPaymentModalVisible(false);
    setSelectedSubscription(null);
  };

  if (loading) {
    return <Spin />;
  }

  return (
    <div>
      <List
        itemLayout="horizontal"
        dataSource={subscriptions}
        renderItem={(item) => {
          return (
            <List.Item
              actions={
                item?.plan?.isDefault
                  ? [] // No button
                  : [
                      <Button
                        onClick={() => handleViewPaymentHistory(item?._id)}
                      >
                        View Payment History
                      </Button>,
                    ]
              }
            >
              <List.Item.Meta
                title={`Subscription: ${item?.plan?.name}`}
                description={`Status: ${
                  subscriptionStates[item?.status]
                } | Start Date: ${
                  item?.startDate
                    ? helper.ISTDate(item?.startDate, "YYYY-MM-DD")
                    : "NA"
                } | End / Next Billing Date: ${
                  item?.endDate
                    ? helper.ISTDate(item?.endDate, "YYYY-MM-DD")
                    : "NA"
                }`}
              />
            </List.Item>
          );
        }}
      />
      <Modal
        title="Payment History"
        open={paymentModalVisible}
        onCancel={handleClosePaymentModal}
        footer={null}
        width={1000}
      >
        <PaymentHistory datas={payments} />
      </Modal>
    </div>
  );
};

export default SubscriptionLogs;
